import React from "react"

const StripePaymentContext = React.createContext({})
export default StripePaymentContext
